import { render, staticRenderFns } from "./ThemeSettingsDirectTopBmw.vue?vue&type=template&id=4cfe2f67&scoped=true"
import script from "./ThemeSettingsDirectTopBmw.vue?vue&type=script&lang=js"
export * from "./ThemeSettingsDirectTopBmw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfe2f67",
  null
  
)

export default component.exports